import React from 'react';
import { FaStar } from 'react-icons/fa';

const Portfolio = () => {
  const testimonials = [
    {
      name: 'Sarah Johnson',
      company: 'TechStart Inc.',
      location: 'San Francisco, USA',
      text: 'IdeasPoint transformed our digital presence completely. Their web development and marketing expertise helped us achieve 300% growth in just 6 months.',
      rating: 5
    },
    {
      name: 'Michael Chen',
      company: 'Global Retail Co.',
      location: 'Singapore',
      text: 'The brand identity they created for us was exactly what we needed. Professional, creative, and they truly understood our vision.',
      rating: 5
    },
    {
      name: 'Emma Williams',
      company: 'DataDrive Analytics',
      location: 'London, UK',
      text: 'Outstanding data analytics consultation. They helped us make sense of our data and implement strategies that increased our ROI by 250%.',
      rating: 5
    }
  ];

  const stats = [
    { number: '20+', label: 'Happy Clients' },
    { number: '100+', label: 'Projects Completed' },
    { number: '15+', label: 'Countries Served' },
    { number: '99%', label: 'Client Retention' }
  ];

  return (
    <section className="portfolio" id="portfolio">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Our Impact</span>
          <h2 className="section-title">
            Trusted by Businesses <span className="gradient-text">Worldwide</span>
          </h2>
          <p className="section-description">
            See what our clients say about their experience working with IdeasPoint
          </p>
        </div>

        <div className="portfolio-stats">
          {stats.map((stat, index) => (
            <div className="portfolio-stat" key={index}>
              <h3>{stat.number}</h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div className="testimonial-card" key={index}>
              <div className="testimonial-stars">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FaStar key={i} />
                ))}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-author">
                <div className="author-avatar">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="author-info">
                  <h4>{testimonial.name}</h4>
                  <p>{testimonial.company}</p>
                  <span>{testimonial.location}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="client-showcase">
          <h3>Industries We Serve</h3>
          <div className="industries">
            <span className="industry-tag">E-commerce</span>
            <span className="industry-tag">Technology</span>
            <span className="industry-tag">Healthcare</span>
            <span className="industry-tag">Finance</span>
            <span className="industry-tag">Education</span>
            <span className="industry-tag">Retail</span>
            <span className="industry-tag">Manufacturing</span>
            <span className="industry-tag">Real Estate</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
